common.View.create('website::layouts.main.Header', {

    onDOMLoad()
    {
        this.showCustomerGroup();
    },

    showCustomerGroup()
    {
        this.element.find('.showCustomerGroupDiscount button')
            .on('click', () => {
                this.element.find('[name="show_customer_group"]').addClass('pointer-events-none opacity-50');

                $.post('/show-customer-group', {
                    'show_customer_group_discount': this.element.find('[name="show_customer_group_discount"]').val()
                })
                    .done((data) => {
                        window.location.reload();
                    });
            });
    },

    setTotalPhysicalAmount(amount)
    {
        this.element

            .find('.cart')

            // Update amount.
            .find('.amount')
                .text(amount)
                .end()

            // Update label.
            .find('.label')
                .text(amount === 1 ? 'product' : 'producten')
                .end()

            .end();
    },

});
